(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    /*
    Vaulted Scents card behaviour (loaded once per page by Shopify):
    1. Add to cart over AJAX, using Horizon's own cart events so the cart
       icon count updates and the cart drawer opens/refreshes.
       Works with Horizon v4+ (@shopify/events) and v1–3 (@theme/events).
       If neither can be loaded, the form submits normally (goes to /cart).
    2. Remembers which card was clicked so Back returns to the same spot
       after infinite scroll, like Horizon's built-in card does.
  */
  (() => {
    if (window.__vsCardInit) return;
    window.__vsCardInit = true;

    let eventsApi;
    const loadEvents = () =>
      (eventsApi ??= import('@shopify/events')
        .then((m) => (m.CartLinesUpdateEvent ? { v: 4, m } : Promise.reject()))
        .catch(() =>
          import('@theme/events').then((m) => (m.CartAddEvent ? { v: 3, m } : null))
        )
        .catch(() => null));

    const fetchCart = () =>
      fetch(((window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart') + '.json', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((r) => r.json());

    const flash = (btn, text, ms = 1600) => {
      if (!btn) return;
      const original = btn.dataset.label || btn.textContent;
      btn.dataset.label = original;
      btn.textContent = text;
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
      }, ms);
    };

    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.classList.contains('vs-form')) return;
      event.preventDefault();

      const btn = event.submitter;
      if (btn) {
        btn.dataset.label = btn.dataset.label || btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }

      const api = await loadEvents();
      if (!api) {
        form.submit(); // fallback: normal post to /cart/add
        return;
      }

      const formData = new FormData(form);
      const variantId = String(formData.get('id'));
      const productId = form.closest('.vs-card')?.dataset.productId;
      const sectionIds = [...document.querySelectorAll('cart-items-component')]
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);
      if (sectionIds.length) formData.append('sections', sectionIds.join(','));

      let deferred;
      if (api.v === 4) {
        const { CartLinesUpdateEvent } = api.m;
        deferred = CartLinesUpdateEvent.createPromise();
        form.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity: 1 }],
            promise: deferred.promise,
          })
        );
      }

      try {
        const addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData,
        }).then((r) => r.json());

        const cart = await fetchCart();
        const didError = Boolean(response.status);

        if (api.v === 4) {
          deferred.resolve({
            cart: api.m.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'vs-product-card',
              sourceId: form.id,
              itemCount: 1,
              productId,
              sections: didError ? undefined : response.sections,
              didError,
            },
          });
        } else if (!didError) {
          form.dispatchEvent(
            new api.m.CartAddEvent(cart, variantId, {
              source: 'vs-product-card',
              itemCount: 1,
              productId,
              sections: response.sections,
            })
          );
        }

        flash(btn, didError ? response.description || response.message || 'Could not add' : 'Added ✓', didError ? 3000 : 1600);
      } catch (error) {
        console.error('[vs-product-card]', error);
        deferred?.reject(error);
        flash(btn, 'Try again', 2000);
      }
    });

    // Phones: start in the one-per-row view (Dossier style) unless the shopper picked 2 per row
    const phone = window.matchMedia('(max-width: 749px)');
    const applyMobileDefault = () => {
      if (!phone.matches) return;
      let saved = null;
      try { saved = sessionStorage.getItem('product-grid-view-mobile'); } catch (e) {}
      if (saved === 'default') return;
      document.querySelectorAll('.product-grid[product-grid-view="default"]').forEach((grid) => {
        if (!grid.querySelector('.vs-card')) return;
        grid.setAttribute('product-grid-view', 'mobile-single');
        const scope = grid.closest('results-list') || document;
        const single = scope.querySelector('input[name="grid-mobile"][value="mobile-single"]');
        if (single) single.checked = true;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyMobileDefault);
    else applyMobileDefault();
    phone.addEventListener('change', () => setTimeout(applyMobileDefault, 50));

    // Back-button position restore with infinite scroll
    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('.vs-card a[href]') : null;
      if (!link || (window.Shopify && Shopify.designMode)) return;
      const item = link.closest('li[id][data-page]');
      if (!item || !item.closest('results-list[infinite-scroll="true"]')) return;

      const url = new URL(window.location.href);
      url.hash = item.id;
      url.searchParams.set('page', item.dataset.page);
      history.replaceState(history.state, '', url.toString());
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vs-bundle-picker-snippet"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function initBundlePicker(root) {
    if (!root) return;

    var productId  = root.dataset.productId;
    var bundleSize = parseInt(root.dataset.bundleSize, 10) || 3;

    var selections   = new Array(bundleSize).fill('');
    var openSlot     = -1;

    var slots          = root.querySelectorAll('.mf-bp__slot');
    var pips           = root.querySelectorAll('.mf-bp__pip');
    var remainingLabel = document.getElementById('mf-bp-remaining-' + productId);
    var combinedInput  = root.querySelector('[data-bundle-combined]');

    /* ── Reposition picker before buy button ── */
    function repositionPicker() {
      var formComponent = document.querySelector('product-form-component');
      if (!formComponent) return;
      var target = formComponent;
      while (target && target.parentElement) {
        if (target.parentElement.classList.contains('group-block-content')) {
          target.parentElement.insertBefore(root, target);
          return;
        }
        target = target.parentElement;
      }
    }
    setTimeout(repositionPicker, 100);
    setTimeout(repositionPicker, 500);

    /* ── Create validation modal ── */
    var modal = document.createElement('div');
    modal.id = 'mf-bp-modal';
    modal.style.cssText = [
      'display:none;position:fixed;top:0;left:0;width:100%;height:100%;',
      'background:rgba(0,0,0,0.5);z-index:99999;',
      'align-items:center;justify-content:center;'
    ].join('');
    modal.innerHTML = [
      '<div style="background:#fff;border-radius:8px;padding:2rem;max-width:480px;width:90%;margin:0 auto;color:#111;">',
      '<h2 style="font-size:1.5rem;font-weight:700;margin:0 0 1rem;color:#111;">Selections Required</h2>',
      '<p style="margin:0 0 0.5rem;font-size:1rem;color:#111;">Please make your choice for:</p>',
      '<p id="mf-bp-modal-missing" style="font-weight:700;margin:0 0 1.5rem;font-size:1rem;color:#111;"></p>',
      '<button id="mf-bp-modal-ok" style="width:100%;padding:1rem;background:#111;color:#fff;border:none;',
      'border-radius:4px;font-size:1rem;font-weight:600;cursor:pointer;">OK</button>',
      '</div>'
    ].join('');
    document.body.appendChild(modal);

    document.getElementById('mf-bp-modal-ok').addEventListener('click', function () {
      modal.style.display = 'none';
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.style.display = 'none';
    });

    function showValidationModal(missingSlots) {
      var names = missingSlots.map(function (i) { return 'Selection ' + (i + 1); });
      document.getElementById('mf-bp-modal-missing').textContent = names.join(', ');
      modal.style.display = 'flex';
    }

    function validate() {
      var missing = [];
      selections.forEach(function (sel, i) {
        if (!sel) missing.push(i);
      });
      return missing;
    }

    /* ── Intercept add to cart buttons ── */
    function interceptAddToCart() {
      var addBtns = document.querySelectorAll(
        '[data-testid="standalone-add-to-cart"], ' +
        'button[name="add"], ' +
        '.add-to-cart-button, ' +
        '[id*="BuyButtons"][id*="add-to-cart"]'
      );
      addBtns.forEach(function (btn) {
        if (btn.dataset.mfIntercepted) return;
        btn.dataset.mfIntercepted = 'true';
        btn.addEventListener('click', function (e) {
          var missing = validate();
          if (missing.length > 0) {
            e.preventDefault();
            e.stopImmediatePropagation();
            missing.forEach(function (i) { slots[i].classList.add('is-invalid'); });
            showValidationModal(missing);
            return false;
          }
          injectPropertiesIntoForm();
        }, true);
      });
    }

    function injectPropertiesIntoForm() {
      var properties = {};
      selections.forEach(function (sel, i) {
        if (sel) properties['Selection ' + (i + 1)] = sel;
      });
      window.__mfBundleProperties = properties;
    }

    if (!window.__mfFetchPatched) {
      window.__mfFetchPatched = true;
      var origFetch = window.fetch;
      window.fetch = function (url, options) {
        if (
          typeof url === 'string' &&
          url.includes('/cart/add') &&
          window.__mfBundleProperties &&
          Object.keys(window.__mfBundleProperties).length > 0
        ) {
          try {
            var opts = options || {};
            var body = opts.body;
            var parsed;
            if (typeof body === 'string') {
              parsed = JSON.parse(body);
            } else if (body instanceof FormData) {
              parsed = {};
              body.forEach(function (val, key) { parsed[key] = val; });
            } else {
              parsed = {};
            }
            parsed.properties = parsed.properties || {};
            var props = window.__mfBundleProperties;
            Object.keys(props).forEach(function (k) {
              parsed.properties[k] = props[k];
            });
            opts.body = JSON.stringify(parsed);
            opts.headers = opts.headers || {};
            opts.headers['Content-Type'] = 'application/json';
            window.__mfBundleProperties = null;
            return origFetch(url, opts);
          } catch (err) {
            window.__mfBundleProperties = null;
          }
        }
        return origFetch.apply(this, arguments);
      };
    }

    function openPanel(index) {
      slots.forEach(function (s, i) {
        var panel   = s.querySelector('.mf-bp__panel');
        var trigger = s.querySelector('.mf-bp__trigger');
        var isThis  = i === index;
        s.classList.toggle('is-open', isThis);
        if (panel) panel.hidden = !isThis;
        if (trigger) trigger.setAttribute('aria-expanded', isThis ? 'true' : 'false');
      });
      openSlot = index;
      if (index >= 0 && index < bundleSize) {
        var inp = slots[index] && slots[index].querySelector('.mf-bp__search-input');
        if (inp) setTimeout(function () { inp.focus(); }, 40);
      }
    }

    function closeAll() {
      slots.forEach(function (s) {
        s.classList.remove('is-open');
        var panel   = s.querySelector('.mf-bp__panel');
        var trigger = s.querySelector('.mf-bp__trigger');
        if (panel) panel.hidden = true;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
      openSlot = -1;
    }

    function selectItem(slotIndex, value, name, inspired, imgSrc) {
      selections[slotIndex] = value;
      var slot      = slots[slotIndex];
      var thumb     = slot.querySelector('[data-thumb]');
      var thumbNum  = slot.querySelector('.mf-bp__thumb-num');
      var titleEl   = slot.querySelector('[data-trigger-title]');
      var subEl     = slot.querySelector('[data-trigger-sub]');
      var clearBtn  = slot.querySelector('[data-clear]');
      var hiddenInp = root.querySelector('[data-bundle-value="' + slotIndex + '"]');

      if (imgSrc) {
        thumb.innerHTML = '<img src="' + imgSrc + '" alt="' + name + '" width="52" height="52" style="width:100%;height:100%;object-fit:cover;display:block;">';
      } else {
        if (thumbNum) thumbNum.style.display = 'none';
      }
      if (titleEl) titleEl.textContent = name;
      if (subEl) subEl.textContent = inspired || '';
      if (clearBtn) clearBtn.hidden = false;
      if (hiddenInp) hiddenInp.value = value;

      slot.classList.add('is-filled');
      slot.classList.remove('is-invalid');
      slot.querySelectorAll('.mf-bp__item').forEach(function (li) {
        li.classList.toggle('is-selected', li.dataset.value === value);
        li.setAttribute('aria-selected', li.dataset.value === value ? 'true' : 'false');
      });

      updateProgress();
      updateCombined();
      closeAll();
    }

    function clearSlot(slotIndex) {
      selections[slotIndex] = '';
      var slot      = slots[slotIndex];
      var thumb     = slot.querySelector('[data-thumb]');
      var thumbNum  = slot.querySelector('.mf-bp__thumb-num');
      var titleEl   = slot.querySelector('[data-trigger-title]');
      var subEl     = slot.querySelector('[data-trigger-sub]');
      var clearBtn  = slot.querySelector('[data-clear]');
      var hiddenInp = root.querySelector('[data-bundle-value="' + slotIndex + '"]');

      if (thumbNum) {
        thumb.innerHTML = '';
        thumb.appendChild(thumbNum);
        thumbNum.style.display = '';
      }
      if (titleEl) titleEl.textContent = 'Selection ' + (slotIndex + 1);
      if (subEl) subEl.textContent = 'Please select an option';
      if (clearBtn) clearBtn.hidden = true;
      if (hiddenInp) hiddenInp.value = '';

      slot.classList.remove('is-filled', 'is-invalid');
      slot.querySelectorAll('.mf-bp__item').forEach(function (li) {
        li.classList.remove('is-selected');
        li.setAttribute('aria-selected', 'false');
      });

      updateProgress();
      updateCombined();
      closeAll();
    }

    function updateProgress() {
      var filled = 0;
      pips.forEach(function (pip, i) {
        var isFilled = !!selections[i];
        pip.classList.toggle('filled', isFilled);
        if (isFilled) filled++;
      });
      var remaining = bundleSize - filled;
      var counter = root.querySelector('.mf-bp__counter');
      if (filled === bundleSize) {
        if (counter) counter.innerHTML = '&#10003; Great — all ' + bundleSize + ' selected!';
      } else {
        if (counter) counter.innerHTML = 'Select <strong>' + remaining + '</strong> more fragrance' + (remaining === 1 ? '' : 's');
      }
      if (remainingLabel) remainingLabel.textContent = remaining;
    }

    function updateCombined() {
      if (!combinedInput) return;
      var allFilled = selections.every(function (s) { return s !== ''; });
      combinedInput.value = allFilled ? selections.join(' | ') : '';
    }

    function filterItems(searchInput, slotIndex) {
      var query   = searchInput.value.toLowerCase().trim();
      var slot    = slots[slotIndex];
      var items   = slot.querySelectorAll('.mf-bp__item');
      var empty   = slot.querySelector('.mf-bp__empty');
      var visible = 0;
      items.forEach(function (item) {
        var matches = !query || (item.dataset.search || '').includes(query);
        item.hidden = !matches;
        if (matches) visible++;
      });
      if (empty) empty.hidden = visible > 0;
    }

    function moveActive(slotIndex, direction) {
      var slot    = slots[slotIndex];
      var visible = Array.from(slot.querySelectorAll('.mf-bp__item:not([hidden])'));
      if (!visible.length) return;
      var current = slot.querySelector('.mf-bp__item.is-active');
      var idx     = current ? visible.indexOf(current) : -1;
      idx += direction;
      if (idx < 0) idx = visible.length - 1;
      if (idx >= visible.length) idx = 0;
      slot.querySelectorAll('.mf-bp__item').forEach(function (li) { li.classList.remove('is-active'); });
      visible[idx].classList.add('is-active');
      visible[idx].scrollIntoView({ block: 'nearest' });
    }

    slots.forEach(function (slot, i) {
      var trigger = slot.querySelector('.mf-bp__trigger');
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-clear]')) return;
          openSlot === i ? closeAll() : openPanel(i);
        });
      }

      var clearBtn = slot.querySelector('[data-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          clearSlot(i);
        });
      }

      var searchInp = slot.querySelector('.mf-bp__search-input');
      if (searchInp) {
        searchInp.addEventListener('input', function () { filterItems(this, i); });
        searchInp.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') { e.preventDefault(); moveActive(i, 1); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); moveActive(i, -1); }
          else if (e.key === 'Enter') {
            e.preventDefault();
            var active = slot.querySelector('.mf-bp__item.is-active:not([hidden])');
            if (active) active.click();
          } else if (e.key === 'Escape') { closeAll(); }
        });
      }

      slot.querySelectorAll('.mf-bp__item').forEach(function (item) {
        item.addEventListener('click', function () {
          selectItem(i, item.dataset.value, item.dataset.name, item.dataset.inspired, item.dataset.img);
        });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); item.click(); }
        });
      });
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll();
    });

    interceptAddToCart();
    setTimeout(interceptAddToCart, 500);
    setTimeout(interceptAddToCart, 1500);
  }

  function init() {
    document.querySelectorAll('.mf-bundle-picker').forEach(function (root) {
      initBundlePicker(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vs-bundle-picker"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function initBundlePicker(root) {
    if (!root) return;

    var productId  = root.dataset.productId;
    var bundleSize = parseInt(root.dataset.bundleSize, 10) || 3;

    var selections   = new Array(bundleSize).fill('');
    var openSlot     = -1;

    var slots          = root.querySelectorAll('.mf-bp__slot');
    var pips           = root.querySelectorAll('.mf-bp__pip');
    var remainingLabel = document.getElementById('mf-bp-remaining-' + productId);
    var combinedInput  = root.querySelector('[data-bundle-combined]');

    /* ── Reposition picker before buy button ── */
    function repositionPicker() {
      var formComponent = document.querySelector('product-form-component');
      if (!formComponent) return;
      var target = formComponent;
      while (target && target.parentElement) {
        if (target.parentElement.classList.contains('group-block-content')) {
          target.parentElement.insertBefore(root, target);
          return;
        }
        target = target.parentElement;
      }
    }
    setTimeout(repositionPicker, 100);
    setTimeout(repositionPicker, 500);

    /* ── Create validation modal ── */
    var modal = document.createElement('div');
    modal.id = 'mf-bp-modal';
    modal.style.cssText = [
      'display:none;position:fixed;top:0;left:0;width:100%;height:100%;',
      'background:rgba(0,0,0,0.5);z-index:99999;',
      'align-items:center;justify-content:center;'
    ].join('');
    modal.innerHTML = [
      '<div style="background:#fff;border-radius:8px;padding:2rem;max-width:480px;width:90%;margin:0 auto;color:#111;">',
      '<h2 style="font-size:1.5rem;font-weight:700;margin:0 0 1rem;color:#111;">Selections Required</h2>',
      '<p style="margin:0 0 0.5rem;font-size:1rem;color:#111;">Please make your choice for:</p>',
      '<p id="mf-bp-modal-missing" style="font-weight:700;margin:0 0 1.5rem;font-size:1rem;color:#111;"></p>',
      '<button id="mf-bp-modal-ok" style="width:100%;padding:1rem;background:#111;color:#fff;border:none;',
      'border-radius:4px;font-size:1rem;font-weight:600;cursor:pointer;">OK</button>',
      '</div>'
    ].join('');
    document.body.appendChild(modal);

    document.getElementById('mf-bp-modal-ok').addEventListener('click', function () {
      modal.style.display = 'none';
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.style.display = 'none';
    });

    function showValidationModal(missingSlots) {
      var names = missingSlots.map(function (i) { return 'Selection ' + (i + 1); });
      document.getElementById('mf-bp-modal-missing').textContent = names.join(', ');
      modal.style.display = 'flex';
    }

    function validate() {
      var missing = [];
      selections.forEach(function (sel, i) {
        if (!sel) missing.push(i);
      });
      return missing;
    }

    /* ── Intercept add to cart buttons ── */
    function interceptAddToCart() {
      var addBtns = document.querySelectorAll(
        '[data-testid="standalone-add-to-cart"], ' +
        'button[name="add"], ' +
        '.add-to-cart-button, ' +
        '[id*="BuyButtons"][id*="add-to-cart"]'
      );
      addBtns.forEach(function (btn) {
        if (btn.dataset.mfIntercepted) return;
        btn.dataset.mfIntercepted = 'true';
        btn.addEventListener('click', function (e) {
          var missing = validate();
          if (missing.length > 0) {
            e.preventDefault();
            e.stopImmediatePropagation();
            missing.forEach(function (i) { slots[i].classList.add('is-invalid'); });
            showValidationModal(missing);
            return false;
          }
          injectPropertiesIntoForm();
        }, true);
      });
    }

    function injectPropertiesIntoForm() {
      var properties = {};
      selections.forEach(function (sel, i) {
        if (sel) properties['Selection ' + (i + 1)] = sel;
      });
      window.__mfBundleProperties = properties;
    }

    if (!window.__mfFetchPatched) {
      window.__mfFetchPatched = true;
      var origFetch = window.fetch;
      window.fetch = function (url, options) {
        if (
          typeof url === 'string' &&
          url.includes('/cart/add') &&
          window.__mfBundleProperties &&
          Object.keys(window.__mfBundleProperties).length > 0
        ) {
          try {
            var opts = options || {};
            var body = opts.body;
            var parsed;
            if (typeof body === 'string') {
              parsed = JSON.parse(body);
            } else if (body instanceof FormData) {
              parsed = {};
              body.forEach(function (val, key) { parsed[key] = val; });
            } else {
              parsed = {};
            }
            parsed.properties = parsed.properties || {};
            var props = window.__mfBundleProperties;
            Object.keys(props).forEach(function (k) {
              parsed.properties[k] = props[k];
            });
            opts.body = JSON.stringify(parsed);
            opts.headers = opts.headers || {};
            opts.headers['Content-Type'] = 'application/json';
            window.__mfBundleProperties = null;
            return origFetch(url, opts);
          } catch (err) {
            window.__mfBundleProperties = null;
          }
        }
        return origFetch.apply(this, arguments);
      };
    }

    function openPanel(index) {
      slots.forEach(function (s, i) {
        var panel   = s.querySelector('.mf-bp__panel');
        var trigger = s.querySelector('.mf-bp__trigger');
        var isThis  = i === index;
        s.classList.toggle('is-open', isThis);
        if (panel) panel.hidden = !isThis;
        if (trigger) trigger.setAttribute('aria-expanded', isThis ? 'true' : 'false');
      });
      openSlot = index;
      if (index >= 0 && index < bundleSize) {
        var inp = slots[index] && slots[index].querySelector('.mf-bp__search-input');
        if (inp) setTimeout(function () { inp.focus(); }, 40);
      }
    }

    function closeAll() {
      slots.forEach(function (s) {
        s.classList.remove('is-open');
        var panel   = s.querySelector('.mf-bp__panel');
        var trigger = s.querySelector('.mf-bp__trigger');
        if (panel) panel.hidden = true;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
      openSlot = -1;
    }

    function selectItem(slotIndex, value, name, inspired, imgSrc) {
      selections[slotIndex] = value;
      var slot      = slots[slotIndex];
      var thumb     = slot.querySelector('[data-thumb]');
      var thumbNum  = slot.querySelector('.mf-bp__thumb-num');
      var titleEl   = slot.querySelector('[data-trigger-title]');
      var subEl     = slot.querySelector('[data-trigger-sub]');
      var clearBtn  = slot.querySelector('[data-clear]');
      var hiddenInp = root.querySelector('[data-bundle-value="' + slotIndex + '"]');

      if (imgSrc) {
        thumb.innerHTML = '<img src="' + imgSrc + '" alt="' + name + '" width="52" height="52" style="width:100%;height:100%;object-fit:cover;display:block;">';
      } else {
        if (thumbNum) thumbNum.style.display = 'none';
      }
      if (titleEl) titleEl.textContent = name;
      if (subEl) subEl.textContent = inspired || '';
      if (clearBtn) clearBtn.hidden = false;
      if (hiddenInp) hiddenInp.value = value;

      slot.classList.add('is-filled');
      slot.classList.remove('is-invalid');
      slot.querySelectorAll('.mf-bp__item').forEach(function (li) {
        li.classList.toggle('is-selected', li.dataset.value === value);
        li.setAttribute('aria-selected', li.dataset.value === value ? 'true' : 'false');
      });

      updateProgress();
      updateCombined();
      closeAll();
    }

    function clearSlot(slotIndex) {
      selections[slotIndex] = '';
      var slot      = slots[slotIndex];
      var thumb     = slot.querySelector('[data-thumb]');
      var thumbNum  = slot.querySelector('.mf-bp__thumb-num');
      var titleEl   = slot.querySelector('[data-trigger-title]');
      var subEl     = slot.querySelector('[data-trigger-sub]');
      var clearBtn  = slot.querySelector('[data-clear]');
      var hiddenInp = root.querySelector('[data-bundle-value="' + slotIndex + '"]');

      if (thumbNum) {
        thumb.innerHTML = '';
        thumb.appendChild(thumbNum);
        thumbNum.style.display = '';
      }
      if (titleEl) titleEl.textContent = 'Selection ' + (slotIndex + 1);
      if (subEl) subEl.textContent = 'Please select an option';
      if (clearBtn) clearBtn.hidden = true;
      if (hiddenInp) hiddenInp.value = '';

      slot.classList.remove('is-filled', 'is-invalid');
      slot.querySelectorAll('.mf-bp__item').forEach(function (li) {
        li.classList.remove('is-selected');
        li.setAttribute('aria-selected', 'false');
      });

      updateProgress();
      updateCombined();
      closeAll();
    }

    function updateProgress() {
      var filled = 0;
      pips.forEach(function (pip, i) {
        var isFilled = !!selections[i];
        pip.classList.toggle('filled', isFilled);
        if (isFilled) filled++;
      });
      var remaining = bundleSize - filled;
      var counter = root.querySelector('.mf-bp__counter');
      if (filled === bundleSize) {
        if (counter) counter.innerHTML = '&#10003; Great — all ' + bundleSize + ' selected!';
      } else {
        if (counter) counter.innerHTML = 'Select <strong>' + remaining + '</strong> more fragrance' + (remaining === 1 ? '' : 's');
      }
      if (remainingLabel) remainingLabel.textContent = remaining;
    }

    function updateCombined() {
      if (!combinedInput) return;
      var allFilled = selections.every(function (s) { return s !== ''; });
      combinedInput.value = allFilled ? selections.join(' | ') : '';
    }

    function filterItems(searchInput, slotIndex) {
      var query   = searchInput.value.toLowerCase().trim();
      var slot    = slots[slotIndex];
      var items   = slot.querySelectorAll('.mf-bp__item');
      var empty   = slot.querySelector('.mf-bp__empty');
      var visible = 0;
      items.forEach(function (item) {
        var matches = !query || (item.dataset.search || '').includes(query);
        item.hidden = !matches;
        if (matches) visible++;
      });
      if (empty) empty.hidden = visible > 0;
    }

    function moveActive(slotIndex, direction) {
      var slot    = slots[slotIndex];
      var visible = Array.from(slot.querySelectorAll('.mf-bp__item:not([hidden])'));
      if (!visible.length) return;
      var current = slot.querySelector('.mf-bp__item.is-active');
      var idx     = current ? visible.indexOf(current) : -1;
      idx += direction;
      if (idx < 0) idx = visible.length - 1;
      if (idx >= visible.length) idx = 0;
      slot.querySelectorAll('.mf-bp__item').forEach(function (li) { li.classList.remove('is-active'); });
      visible[idx].classList.add('is-active');
      visible[idx].scrollIntoView({ block: 'nearest' });
    }

    slots.forEach(function (slot, i) {
      var trigger = slot.querySelector('.mf-bp__trigger');
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-clear]')) return;
          openSlot === i ? closeAll() : openPanel(i);
        });
      }

      var clearBtn = slot.querySelector('[data-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          clearSlot(i);
        });
      }

      var searchInp = slot.querySelector('.mf-bp__search-input');
      if (searchInp) {
        searchInp.addEventListener('input', function () { filterItems(this, i); });
        searchInp.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') { e.preventDefault(); moveActive(i, 1); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); moveActive(i, -1); }
          else if (e.key === 'Enter') {
            e.preventDefault();
            var active = slot.querySelector('.mf-bp__item.is-active:not([hidden])');
            if (active) active.click();
          } else if (e.key === 'Escape') { closeAll(); }
        });
      }

      slot.querySelectorAll('.mf-bp__item').forEach(function (item) {
        item.addEventListener('click', function () {
          selectItem(i, item.dataset.value, item.dataset.name, item.dataset.inspired, item.dataset.img);
        });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); item.click(); }
        });
      });
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll();
    });

    interceptAddToCart();
    setTimeout(interceptAddToCart, 500);
    setTimeout(interceptAddToCart, 1500);
  }

  function init() {
    document.querySelectorAll('.mf-bundle-picker').forEach(function (root) {
      initBundlePicker(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vs-cart-progress"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__vsCobar) return;
    window.__vsCobar = true;
    const init = () => {
      const page = document.querySelector('.cart-page');
      if (!page) return;
      const bar = document.createElement('div');
      bar.className = 'vs-cobar';
      bar.innerHTML = '<span class="vs-cobar__total">Total<b data-vs-bar-total></b></span><button type="submit" form="cart-form" name="checkout" class="vs-cobar__btn">Go to checkout</button>';
      document.body.appendChild(bar);
      const totalEl = bar.querySelector('[data-vs-bar-total]');
      const sync = () => {
        const t = document.querySelector('.cart-page [data-vs-cart-total]');
        if (t) totalEl.textContent = t.textContent.trim();
      };
      sync();
      new MutationObserver(sync).observe(page.closest('.shopify-section') || page, { childList: true, subtree: true, characterData: true });
      // Hide the bar while the real checkout buttons are on screen
      let realVisible = false;
      const io = new IntersectionObserver((entries) => {
        realVisible = entries.some((e) => e.isIntersecting);
        bar.classList.toggle('is-on', !realVisible);
      });
      const watch = () => document.querySelectorAll('.cart-page .cart__ctas').forEach((el) => io.observe(el));
      watch();
      new MutationObserver(watch).observe(page, { childList: true, subtree: true });
      bar.classList.add('is-on');
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vs-cart-toast"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__vsToast) return;
    window.__vsToast = true;

    let el, timer;
    const build = () => {
      el = document.createElement('div');
      el.className = 'vs-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.innerHTML = `
        <span class="vs-toast__tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>
        <span class="vs-toast__text"><span class="vs-toast__title"></span><span class="vs-toast__sub"></span></span>
        <a class="vs-toast__btn" href="${(window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart'}">View cart</a>
        <button type="button" class="vs-toast__x" aria-label="Close">&times;</button>`;
      document.body.appendChild(el);
      el.querySelector('.vs-toast__x').addEventListener('click', hide);
      el.querySelector('.vs-toast__btn').addEventListener('click', (e) => {
        // Open the cart drawer if the theme has one, otherwise go to the cart page
        const trigger = document.querySelector('[on\\:click="#cart-drawer/toggle"], [on\\:click="#cart-drawer/open"]');
        if (trigger) { e.preventDefault(); hide(); trigger.click(); }
      });
      el.addEventListener('mouseenter', () => clearTimeout(timer));
      el.addEventListener('mouseleave', () => (timer = setTimeout(hide, 2500)));
    };
    const hide = () => el && el.classList.remove('is-on');
    const show = ({ error = false, count } = {}) => {
      if (!el) build();
      el.classList.toggle('vs-toast--error', error);
      el.querySelector('.vs-toast__title').textContent = error ? "Couldn't add to cart" : 'Added to your cart';
      el.querySelector('.vs-toast__sub').textContent = error ? 'Please try again or choose another size.' : (count ? `${count} item${count === 1 ? '' : 's'} in your cart` : 'Free UK delivery over £24');
      el.querySelector('.vs-toast__btn').hidden = error;
      el.classList.add('is-on');
      clearTimeout(timer);
      timer = setTimeout(hide, 4500);
    };
    window.vsCartToast = show;

    // Horizon v4+: cart events from @shopify/events
    import('@shopify/events').then(({ StandardEvents }) => {
      if (!StandardEvents || !StandardEvents.cartLinesUpdate) throw 0;
      document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
        if (event.action && event.action !== 'add') return;
        event.promise?.then(({ cart, detail }) => {
          show({ error: !!detail?.didError, count: cart?.totalQuantity ?? detail?.itemCount });
        }).catch(() => {});
      });
    }).catch(() =>
      // Older Horizon: cart:update events
      import('@theme/events').then(({ ThemeEvents }) => {
        document.addEventListener(ThemeEvents.cartUpdate, (event) => {
          const d = event.detail || {};
          if (d.data?.source === 'cart-items-component') return;
          show({ error: !!d.data?.didError, count: d.resource?.item_count });
        });
      }).catch(() => {})
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vs-filter-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__vsFbar) return;
    window.__vsFbar = true;

    // Sort dropdown in the toolbar
    document.addEventListener('change', (e) => {
      const sel = e.target instanceof Element ? e.target.closest('[data-vs-sort]') : null;
      if (!sel) return;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      url.hash = '';
      window.location.href = url.toString();
    });
    const desktop = window.matchMedia('(min-width: 750px)');
    window.addEventListener('scroll', () => {
      document.querySelectorAll('dialog.vs-sheet.is-drop[open]').forEach((o) => o.close());
    }, { passive: true });

    document.addEventListener('click', (e) => {
      if (!(e.target instanceof Element)) return;
      const opener = e.target.closest('[data-vs-open]');
      if (opener) {
        const d = document.getElementById(opener.dataset.vsOpen);
        if (!d || !d.showModal) return;
        const wasOpen = d.open;
        document.querySelectorAll('dialog.vs-sheet[open]').forEach((o) => o.close());
        if (wasOpen) return;
        // Always open in the browser's top layer, so product cards can never cover it
        d.showModal();
        if (desktop.matches && d.id !== 'vs-sheet-all') {
          d.classList.add('is-drop');
          const r = opener.getBoundingClientRect();
          const w = d.offsetWidth;
          d.style.top = Math.round(r.bottom + 8) + 'px';
          d.style.left = Math.round(Math.min(Math.max(12, r.left), window.innerWidth - w - 12)) + 'px';
        } else {
          d.classList.remove('is-drop');
          d.style.top = d.style.left = '';
          document.documentElement.style.overflow = 'hidden';
        }
        opener.setAttribute('aria-expanded', 'true');
        return;
      }
      if (e.target.closest('[data-vs-close]')) {
        e.target.closest('dialog')?.close();
        return;
      }
      // tap on the dark backdrop closes the sheet
      if (e.target instanceof HTMLDialogElement && e.target.classList.contains('vs-sheet')) e.target.close();
    });

    document.addEventListener('close', (e) => {
      if (!(e.target instanceof HTMLDialogElement) || !e.target.classList.contains('vs-sheet')) return;
      document.documentElement.style.overflow = '';
      document.querySelectorAll('[data-vs-open="' + e.target.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    }, true);

    // Keep the same option in sync between its own sheet and the "Filter" sheet
    document.addEventListener('change', (e) => {
      const cb = e.target;
      if (!(cb instanceof HTMLInputElement) || cb.type !== 'checkbox' || !cb.closest('[data-vs-fbar-form]')) return;
      const form = cb.closest('[data-vs-fbar-form]');
      form.querySelectorAll('input[type="checkbox"]').forEach((other) => {
        if (other !== cb && other.name === cb.name && other.value === cb.value) other.checked = cb.checked;
      });
      const sheet = cb.closest('dialog');
      if (sheet && sheet.classList.contains('is-drop')) form.requestSubmit();
    });

    // Search box inside long lists
    document.addEventListener('input', (e) => {
      const box = e.target;
      if (!(box instanceof HTMLInputElement) || !box.hasAttribute('data-vs-search')) return;
      const q = box.value.trim().toLowerCase();
      box.closest('.vs-sheet__body').querySelectorAll('.vs-fval li').forEach((li) => {
        li.hidden = q && !li.textContent.toLowerCase().includes(q);
      });
    });

    // Submit: drop empty price inputs and duplicate values so the URL stays clean
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-vs-fbar-form')) return;
      e.preventDefault();
      const params = new URLSearchParams();
      const seen = new Set();
      new FormData(form).forEach((v, k) => {
        if (v === '' ) return;
        const key = k + '=' + v;
        if (seen.has(key)) return;
        seen.add(key);
        params.append(k, v);
      });
      window.location.href = form.getAttribute('action') + '?' + params.toString();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vs-grid-promo"] && !Shopify.designMode) return;
  try {
    /* Hide a tile until its product position has loaded (infinite scroll), so it
     never sits at the end of a half-loaded list. On the last page it always shows. */
  (() => {
    const update = () => {
      document.querySelectorAll('.product-grid').forEach((grid) => {
        const tiles = grid.querySelectorAll(':scope > .vs-promo-item');
        if (!tiles.length) return;
        const loaded = grid.querySelectorAll(':scope > [data-product-id]').length;
        const pages = [...grid.querySelectorAll(':scope > [data-page]')].map((li) => Number(li.dataset.page));
        const onLastPage = Math.max(0, ...pages) >= Number(grid.dataset.lastPage || 1);
        tiles.forEach((tile) => {
          const pos = Number(tile.dataset.vsPos || 0);
          tile.classList.toggle('vs-promo-item--waiting', !onLastPage && pos > loaded);
        });
      });
    };
    const start = () => {
      update();
      new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-vs-promo-pause]') : null;
    if (!button) return;
    const video = button.parentElement.querySelector('video');
    if (!video) return;
    if (video.paused) {
      video.play();
      button.setAttribute('aria-label', 'Pause video');
      button.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><rect x="3" y="2" width="2.5" height="10" rx="1" fill="currentColor"/><rect x="8.5" y="2" width="2.5" height="10" rx="1" fill="currentColor"/></svg>';
    } else {
      video.pause();
      button.setAttribute('aria-label', 'Play video');
      button.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M4 2.5v9l7.5-4.5z" fill="currentColor"/></svg>';
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vs-popular-searches"] && !Shopify.designMode) return;
  try {
    /* Clicking a pill types the term into the search box, so results show instantly */
  document.addEventListener('click', (event) => {
    const pill = event.target instanceof Element ? event.target.closest('[data-vs-popular]') : null;
    if (!pill) return;
    const scope = pill.closest('dialog, predictive-search-component, .search-modal') || document;
    const input = scope.querySelector('input[type="search"], input[name="q"]');
    if (!input) return; // no search box nearby: follow the link to the search page
    event.preventDefault();
    input.value = pill.dataset.vsPopular;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vs-product-card"] && !Shopify.designMode) return;
  try {
    /*
    Vaulted Scents card behaviour (loaded once per page by Shopify):
    1. Add to cart over AJAX, using Horizon's own cart events so the cart
       icon count updates and the cart drawer opens/refreshes.
       Works with Horizon v4+ (@shopify/events) and v1–3 (@theme/events).
       If neither can be loaded, the form submits normally (goes to /cart).
    2. Remembers which card was clicked so Back returns to the same spot
       after infinite scroll, like Horizon's built-in card does.
  */
  (() => {
    if (window.__vsCardInit) return;
    window.__vsCardInit = true;

    let eventsApi;
    const loadEvents = () =>
      (eventsApi ??= import('@shopify/events')
        .then((m) => (m.CartLinesUpdateEvent ? { v: 4, m } : Promise.reject()))
        .catch(() =>
          import('@theme/events').then((m) => (m.CartAddEvent ? { v: 3, m } : null))
        )
        .catch(() => null));

    const fetchCart = () =>
      fetch(((window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart') + '.json', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((r) => r.json());

    const flash = (btn, text, ms = 1600) => {
      if (!btn) return;
      const original = btn.dataset.label || btn.textContent;
      btn.dataset.label = original;
      btn.textContent = text;
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
      }, ms);
    };

    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.classList.contains('vs-form')) return;
      event.preventDefault();

      const btn = event.submitter;
      if (btn) {
        btn.dataset.label = btn.dataset.label || btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }

      const api = await loadEvents();
      if (!api) {
        form.submit(); // fallback: normal post to /cart/add
        return;
      }

      const formData = new FormData(form);
      const variantId = String(formData.get('id'));
      const productId = form.closest('.vs-card')?.dataset.productId;
      const sectionIds = [...document.querySelectorAll('cart-items-component')]
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);
      if (sectionIds.length) formData.append('sections', sectionIds.join(','));

      let deferred;
      if (api.v === 4) {
        const { CartLinesUpdateEvent } = api.m;
        deferred = CartLinesUpdateEvent.createPromise();
        form.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity: 1 }],
            promise: deferred.promise,
          })
        );
      }

      try {
        const addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData,
        }).then((r) => r.json());

        const cart = await fetchCart();
        const didError = Boolean(response.status);

        if (api.v === 4) {
          deferred.resolve({
            cart: api.m.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'vs-product-card',
              sourceId: form.id,
              itemCount: 1,
              productId,
              sections: didError ? undefined : response.sections,
              didError,
            },
          });
        } else if (!didError) {
          form.dispatchEvent(
            new api.m.CartAddEvent(cart, variantId, {
              source: 'vs-product-card',
              itemCount: 1,
              productId,
              sections: response.sections,
            })
          );
        }

        flash(btn, didError ? response.description || response.message || 'Could not add' : 'Added ✓', didError ? 3000 : 1600);
      } catch (error) {
        console.error('[vs-product-card]', error);
        deferred?.reject(error);
        flash(btn, 'Try again', 2000);
      }
    });

    // Layout switch (buttons in vs-filter-bar): "grid" or "list"
    //   Phones:  list (1 per row) by default, grid = 2 per row
    //   Desktop: grid (4 per row) by default, list = 1 per row, same card as phones
    const phone = window.matchMedia('(max-width: 749px)');
    const viewKey = () => (phone.matches ? 'vsViewMobile' : 'vsViewDesktop');
    const currentView = () => {
      let v = null;
      try { v = sessionStorage.getItem(viewKey()); } catch (e) {}
      return v === 'grid' || v === 'list' ? v : (phone.matches ? 'list' : 'grid');
    };
    const applyView = () => {
      const view = currentView();
      document.querySelectorAll('.product-grid').forEach((grid) => {
        if (!grid.querySelector('.vs-card')) return;
        if (phone.matches) {
          // phones: Horizon's own attribute (mobile-single = 1 per row, default = 2 per row)
          if (grid.hasAttribute('data-vs-list')) grid.removeAttribute('data-vs-list');
          const attr = view === 'list' ? 'mobile-single' : 'default';
          if (grid.getAttribute('product-grid-view') !== attr) grid.setAttribute('product-grid-view', attr);
        } else {
          // desktop: our own flag, so the theme's scripts can't switch it back
          if (grid.getAttribute('product-grid-view') !== 'default') grid.setAttribute('product-grid-view', 'default');
          if (view === 'list') { if (!grid.hasAttribute('data-vs-list')) grid.setAttribute('data-vs-list', ''); }
          else if (grid.hasAttribute('data-vs-list')) grid.removeAttribute('data-vs-list');
        }
      });
      document.querySelectorAll('[data-vs-view]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.vsView === view)));
    };
    document.addEventListener('click', (event) => {
      const btn = event.target instanceof Element ? event.target.closest('[data-vs-view]') : null;
      if (!btn) return;
      event.preventDefault();
      try { sessionStorage.setItem(viewKey(), btn.dataset.vsView); } catch (e) {}
      applyView();
    });
    let viewTimer;
    new MutationObserver(() => { clearTimeout(viewTimer); viewTimer = setTimeout(applyView, 30); })
      .observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['product-grid-view'] });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyView);
    else applyView();
    phone.addEventListener('change', applyView);

    // Back-button position restore with infinite scroll
    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('.vs-card a[href]') : null;
      if (!link || (window.Shopify && Shopify.designMode)) return;
      const item = link.closest('li[id][data-page]');
      if (!item || !item.closest('results-list[infinite-scroll="true"]')) return;

      const url = new URL(window.location.href);
      url.hash = item.id;
      url.searchParams.set('page', item.dataset.page);
      history.replaceState(history.state, '', url.toString());
    });
  })();

  /* Deal price (i): builds one explainer pop-up for the whole page and opens it */
  (() => {
    if (window.__vsCardDeal) return;
    window.__vsCardDeal = true;
    const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const rows = (txt) => String(txt || '').split(',').map((t) => {
      const i = t.indexOf(':');
      if (i < 0) return '';
      const q = t.slice(0, i).trim();
      const raw = t.slice(i + 1).trim();
      let left, right;
      if (raw.includes('|')) {
        [left, right] = raw.split('|').map((x) => x.trim());
      } else {
        left = q === '1' ? 'Any 1 item' : `Any ${q}+ items`;
        const first = raw.toLowerCase().split(' ')[0];
        right = ['get', 'save', 'free'].includes(first) ? raw : `Get ${raw}`;
      }
      return `<li><span>${esc(left)}</span><b>${esc(right)}</b></li>`;
    }).join('');
    let sheet;
    const open = (btn) => {
      const d = btn.dataset;
      if (!sheet) {
        sheet = document.createElement('dialog');
        sheet.className = 'vs-dealsheet';
        sheet.setAttribute('aria-labelledby', 'vs-cdeal-title');
        document.body.appendChild(sheet);
        sheet.addEventListener('click', (e) => {
          if (e.target === sheet || (e.target instanceof Element && e.target.closest('[data-vs-close-deal]'))) sheet.close();
        });
      }
      sheet.innerHTML = `<div class="vs-dealsheet__inner">
        <button type="button" class="vs-dealsheet__close" data-vs-close-deal>Close</button>
        ${d.kicker ? `<p class="vs-dealsheet__kicker">${esc(d.kicker)}</p>` : ''}
        <h2 class="vs-dealsheet__title" id="vs-cdeal-title">${esc(d.title || 'Buy more, save more')}</h2>
        ${d.sub ? `<p class="vs-dealsheet__sub">${esc(d.sub)}</p>` : ''}
        <ul class="vs-dealsheet__tiers" role="list">${rows(d.tiers)}</ul>
        <button type="button" class="vs-dealsheet__cta" data-vs-close-deal>${esc(d.btn || 'Continue shopping')}</button>
        ${d.note ? `<p class="vs-dealsheet__note">${esc(d.note)}</p>` : ''}
      </div>`;
      if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open', '');
    };
    document.addEventListener('click', (e) => {
      const btn = e.target instanceof Element ? e.target.closest('[data-vs-cdeal]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      open(btn);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
